<template>
    <div class="card">
        <div class="card-header">
            <div class="row">
                <div class="col-md-6">
                    <h4 class="m-b-0"><i class="fas fa-tractor"></i> Contract Items</h4>
                </div>
                <div class="col-md-6 text-right" v-if="contract.status === 'DRAFT'">
                    <div class="button-group">
                        <a @click="getContractGoods()" class="btn btn-success waves-effect waves-light"
                           data-target="#contractItems"
                           data-toggle="modal" href="javasript:void(0);">
                            <i class="fas fa-edit"></i> Edit
                        </a>
                    </div>
                </div>
            </div>
        </div>

        <div class="table-responsive" v-if="contract.goods_services.length>0">
            <table class="table v-middle">
                <thead>
                <tr class="bg-light">
                    <th class="border-top-0"><h6>#</h6></th>
                    <th class="border-top-0"><h6>Name</h6></th>
                    <th class="border-top-0"><h6>Properties</h6></th>
                    <th class="border-top-0"><h6>Provenance</h6></th>
                    <th class="border-top-0"><h6>Quantity</h6></th>
                    <th class="border-top-0"><h6>Rate</h6></th>
                </tr>
                </thead>
                <tbody>
                <tr v-bind:key="index" v-for="(gs, index) in contract.goods_services">
                    <td class="v-align-t">{{index+1}}</td>
                    <td class="v-align-t">{{gs.name}} - {{gs.variety}}</td>
                    <td class="v-align-t pl-0">
                        <ul>
                            <li v-for="(gsp, index) in gs.props">
                                <b>{{gsp.key}} :</b> {{gsp.value}}
                            </li>
                        </ul>
                    </td>
                    <td class="v-align-t">
                        <a :href="gs.provenance" v-if="gs.provenance">{{gs.provenance}}</a>
                        <span v-else>NA</span>
                    </td>
                    <td class="v-align-t">{{gs.quantity | units}}</td>
                    <td class="v-align-t">{{gs.rate | money}}</td>
                </tr>
                </tbody>
            </table>
        </div>
        <div class="card-body card-blue" v-else>
            <h4 class="card-title text-muted text-center">No records found</h4>
        </div>

        <div aria-labelledby="contractItems" class="modal fade" id="contractItems" role="dialog" tabindex="-1">
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-body card-blue">
                        <div class="card-body">
                            <h4 class="card-title">Contract Item</h4>
                            <h5 class="card-subtitle">Overview of contract type, parties, products, prices</h5>
                            <!-- Tab panes -->
                            <div class="tab-content">
                                <div class="tab-pane active" id="properties" role="tabpanel">
                                    <div class="row">
                                        <div class="col-md-12">
                                            <form>
                                                <div class="form-group row" v-for="(row, index) in rows">
                                                    <!-- Good/Service -->
                                                    <div class="col-sm-4">
                                                        <multiselect
                                                                :class="{'is-invalid': submitted && errors.has('goodsservice')}"
                                                                :clear-on-select="false"
                                                                :close-on-select="true"
                                                                :hide-selected="true"
                                                                :internal-search="false"
                                                                :limit="3"
                                                                :loading="isLoading"
                                                                :max-height="600"
                                                                :options="services"
                                                                :options-limit="300"
                                                                :searchable="true"
                                                                :show-no-results="false"
                                                                @input="setUnit(row)"
                                                                @search-change="getGoodsServices"
                                                                class="form-control"
                                                                data-vv-as="goodsservice"
                                                                id="goodsservice"
                                                                label="goodsservice"
                                                                name="goodsservice"
                                                                open-direction="bottom"
                                                                placeholder="Search Goods/Service"
                                                                selectLabel=""
                                                                track-by="id"
                                                                v-model="row.good">
                                                            <template slot="singleLabel" slot-scope="props">
                                                                <div class="option__desc">
                                                                    <div class="option__desc" style="text-overflow: ellipsis;white-space: nowrap;overflow: hidden;">
                                                                        {{ props.option.name }} - {{ props.option.variety }}
                                                                    </div>
                                                                </div>
                                                            </template>
                                                            <template slot="option" slot-scope="props">
                                                                <div class="option__desc">
                                                                    <div class="option__desc" v-if="props.option">
                                                                        <h5>{{ props.option.name }}</h5>
                                                                        {{ props.option.variety }}
                                                                    </div>
                                                                    <div class="option__desc" v-else>
                                                                        <h5>Add New</h5>
                                                                    </div>
                                                                </div>
                                                            </template>
                                                        </multiselect>
                                                        <div class="invalid-feedback"
                                                             v-if="submitted && errors.has('goodsservice')">{{
                                                            errors.first('goodsservice') }}
                                                        </div>
                                                    </div>
                                                    <!-- Quantity -->
                                                    <div class="col-sm-2 p-l-0 p-r-0">
                                                        <div class="input-group">
                                                            <input :class="{'is-invalid': submitted && errors.has('quantity'+index)}"
                                                                   :id="'quantity'+index"
                                                                   :name="'quantity'+index"
                                                                   class="form-control"
                                                                   data-vv-as="quantity"
                                                                   placeholder="Quantity"
                                                                   style="height: 42px; width: calc(100% - 70px)"
                                                                   type="number"
                                                                   v-model="row.quantity.amount">
                                                            <input :class="{'is-invalid': submitted && errors.has('quantity'+index)}"
                                                                   :value="row.unit.symbol" class="form-control"
                                                                   disabled>
                                                        </div>
                                                        <div class="invalid-feedback" style="display: block"
                                                             v-if="submitted && errors.has('quantity'+index)">{{
                                                            errors.first('quantity'+index) }}
                                                        </div>
                                                    </div>
                                                    <!-- Rate -->
                                                    <div class="col-sm-2 p-r-0">
                                                        <div class="input-group">
                                                            <input :class="{'is-invalid': submitted && errors.has('rate'+index)}"
                                                                   :value="currency"
                                                                   class="form-control"
                                                                   disabled>
                                                            <input :class="{'is-invalid': submitted && errors.has('rate'+index)}"
                                                                   :id="'rate'+index"
                                                                   :name="'rate'+index"
                                                                   class="form-control"
                                                                   data-vv-as="rate"
                                                                   placeholder="Rate"
                                                                   step="any"
                                                                   style="height: 42px; width: calc(100% - 50px)"
                                                                   type="number"
                                                                   v-model="row.rate.amount">
                                                        </div>
                                                        <div class="invalid-feedback"
                                                             style="display: block"
                                                             v-if="submitted && errors.has('rate'+index)">
                                                            {{
                                                            errors.first('rate'+index)
                                                            }}
                                                        </div>
                                                    </div>

                                                    <div class="col-sm-3 p-r-0">
                                                        <div class="input-group">
                                                            <input :id="'provenance'+index"
                                                                   :name="'provenance'+index"
                                                                   class="form-control"
                                                                   data-vv-as="provenance"
                                                                   placeholder="Provenance"
                                                                   style="height: 42px; width: calc(100% - 70px)"
                                                                   type="text"
                                                                   v-model="row.provenance">
                                                        </div>
                                                    </div>

                                                    <div class="col-sm-1">
                                                        <div class="form-group button-group">
                                                            <button @click="addRow()" class="btn btn-success"
                                                                    type="button"
                                                                    v-if="index === rows.length - 1"><i
                                                                    class="fa fa-plus"></i></button>
                                                            <button @click="removeRow(index)" class="btn btn-danger"
                                                                    type="button" v-else><i
                                                                    class="fa fa-minus"></i></button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button @click="updateItems()" class="btn waves-effect waves-light btn-success"
                                data-dismiss="modal"
                                type="submit">Submit
                        </button>
                        <button class="btn waves-effect waves-light btn-secondary" type="button">Reset</button>
                        <button class="btn waves-effect waves-light btn-danger" data-dismiss="modal" type="button">
                            Cancel
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    import Multiselect from 'vue-multiselect';
    import UnitSelect from "../../common/UnitSelect";

    export default {
        name: "ContractItems",
        props: ['contract'],
        computed: {
            ...mapGetters(["currentUser", "currentOrg"])
        },
        components: {Multiselect, UnitSelect},
        data() {
            return {
                submitted: false,
                isLoading: false,
                currency: null,
                expressid: null,
                rows: [
                    {
                        good: null,
                        quantity: {
                            amount: null
                        },
                        rate: {
                            amount: null
                        },
                        provenance: null,
                        unit: {}
                    }
                ],
                services: [],
            }
        },
        mounted() {
            this.expressid = this.currentOrg.express_id;
            this.currency = this.currentOrg.currency_symbol;
            this.rows = this.contract.goods_services && this.contract.goods_services.length > 0 ? this.contract.goods_services : this.rows;
        },
        methods: {
            getContractGoods() {
                this.rows = this.contract.goods_services;
            },
            async getGoodsServices(searchText) {
                this.isLoading = true;
                let reply;
                if (this.contract.type === 'PURCHASE') {
                    reply = await this.$http.get("/express/" + this.expressid + "/purchases/goodsservices/search", {
                        params: {
                            search: searchText,
                            excludeOld: true
                        }
                    });
                    this.services = reply.data;
                } else if (this.contract.type === 'SALE') {
                    reply = await this.$http.get("/express/" + this.expressid + "/sales/goodsservices/search", {
                        params: {
                            search: searchText,
                            excludeOld: true
                        }
                    });
                    this.services = reply.data;
                }
                this.isLoading = false;
            },
            setUnit(row) {
                if (row) {
                    row.unit = row.good.unit;
                    row.rate.amount = row.good.rate.amount;
                }
            },

            addRow() {
                this.rows.push({
                    good: null,
                    quantity: {
                        amount: null
                    },
                    rate: {
                        amount: null
                    },
                    provenance: null,
                    unit: {}
                });
            },
            removeRow(index) {
                this.rows.splice(index, 1);
            },
            async updateItems() {
                try {
                    await this.$http.post(`/express/${this.currentOrg.express_id}/contracts/${this.contract.id}/updateitems`, this.rows);
                    this.$root.$emit('refreshContract');
                    this.$toastr('success', 'Contract updated successfully', 'Contract Updation');
                    this.$router.push({name: "viewcontract", params: {contractid: this.contract.id}});
                } catch (e) {

                }
            }
        }
    }
</script>

<style scoped>

</style>